module.exports = __webpack_public_path__ + "img/icon4-1(2).dc74965d.png";